export default __webpack_public_path__ + "static/media/ph.8ed53330.svg";